<template>
   <div class="home">
    <router-view></router-view>
   </div>
</template>

<style>
.home{
  text-align: center;
}
</style>